<template>
  <div
    class="h-full"
    v-loading="tableLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="icon-search__input mt-10px">
      <el-input
        placeholder="设备名称或编码"
        v-model="keyword"
        size="small"
        clearable
        @keypress.enter.native="currentChange(1)"
      >
        <i slot="append" class="el-icon-search cursor-pointer" @click="currentChange(1)"></i>
      </el-input>
    </div>
    <div class="h-[calc(100%-124px)] overflow-y-auto p-10px text-[#fff]">
      <div v-for="(item, index) in tableData" :key="index" class="device-card mb-16px p-12px bg-[#136a7dcc] rounded-md cursor-pointer" @click="rowClick(item)">
        <div class="text-16px font-bold mb-12px">{{ item.deviceName }}</div>
        <div class="flex justify-between items-center mb-10px text-12px">
          <div class="">{{ item.deviceCode }}</div>
          <div class="">{{ item.diagTime }}</div>
        </div>
        <div class="border-t border-[#497f7ac9] my-10px"></div>
        <div class="">
          <div class="text-16px mb-10px">{{ item.faultLocation }}</div>
          <div class="text-14px bg-[#b05303] p-5px">
            <div>故障类型：{{ item.fault || '--' }}</div>
            <div>危害：{{ item.harm || '--' }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      class="mt-10px flex justify-center"
      background
      @current-change="currentChange"
      @size-change="sizeChange"
      :current-page="initPagination.pageNum"
      :page-size="initPagination.pageSize"
      layout="total, prev, pager, next"
      :total="initPagination.total"
      :pager-count="5"
    >
    </el-pagination>
  </div>
</template>

<script>
import _ from 'lodash'
import { DeviceDiagnosisApi } from '@wiz-api/large-screen-management'

const deviceDiagnosisApi = new DeviceDiagnosisApi()
export default {
  name: 'abnormalDevice',
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      tableData: [],
      tableLoading: false,
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  methods: {
    async rowClick(row) {
      this.$emit('row-click', row)
    },
    currentChange(val) {
      this.initPagination.pageNum = val
      this.getList()
    },
    sizeChange(val) {
      this.initPagination.pageSize = val
      this.initPagination.pageNum = 1
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await deviceDiagnosisApi.getPageResult({
        maxResultCount: this.initPagination.pageSize,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        keyword: this.keyword
      })
      if (!err) {
        res.items.forEach((item) => {
          item.name = item.deviceName
          item.code = item.deviceCode
        })
        this.tableData = res.items
        this.initPagination.total = res.totalCount
      }
      this.tableLoading = false
    },
  },
  computed: {
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  async created() {
    this.getList()
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
  .el-pagination {
    padding: 2px 0;
    .el-pagination__total {
      font-size: 12px;
      margin-right: 5px;
    }
    .el-pager {
      li {
        margin: 0 1px;
        font-size: 12px;
        min-width: 25px;
      }
    }
    .btn-prev,
    .btn-next {
      margin: 0 1px;
      min-width: 25px;
    }
  }
}
.device-card {
  transition: all 0.3s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}
</style>
